import {createContext} from 'react'

const CatTipoEspacioContext = createContext()

export default CatTipoEspacioContext